// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_b_2_b_operations_packing_mfe_styles" + "." + "17d45ec4" + ".chunk.css";
};